import type * as React from 'react';

import { Description } from '../Description';
import { Heading } from '../Heading';

type CardDetailedHeaderProps = {
    title: React.ReactNode;
    icon?: React.ReactNode;
    description: React.ReactNode;
    details?: React.ReactNode;
    badge?: React.ReactNode;
};

/**
 * A header section with a title, description, and details.
 */
export function CardDetailedHeader(props: CardDetailedHeaderProps) {
    return (
        <div className="flex flex-grow justify-between gap-2">
            <div className="flex flex-1 flex-col">
                <div className="flex items-center gap-2">
                    {props.icon ? (
                        <span className="m-nudge-icon text-muted">{props.icon}</span>
                    ) : null}
                    <Heading>{props.title}</Heading>
                    {props.badge ? props.badge : null}
                </div>
                <Description className="text-muted text-ui-base">{props.description}</Description>
            </div>
            {props.details ? props.details : null}
        </div>
    );
}
